import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

function PrivateRoute({ children, paramsName, encodeTheUri, logicHandler, ...rest }) {
	return (
		<Route
			{...rest}
			render={({ location, ...restRouteProps }) => {
				const params = new URLSearchParams(window.location.search);
				const pathName = ((window || {}).location || {}).pathname;
				let paramsFound = false;
				let obj = {};
				if (paramsName && paramsName.length > 0 && !logicHandler) {
					paramsFound = true;
					for (let val of paramsName) {
						let searchValue = encodeTheUri
							? encodeURIComponent(params.get(val))
							: params.get(val);
						if (searchValue) {
							obj[val] = searchValue;
						} else {
							paramsFound = false;
							break;
						}
					}
				}
				if (paramsFound || (logicHandler && logicHandler(params, pathName, obj))) {
					location.state = obj;
					return React.cloneElement(children, location);
				} else {
					return <Redirect to="/error" />;
				}
			}}
		/>
	);
}
PrivateRoute.defaultProps = {
	encodeTheUri: false
};
PrivateRoute.propTypes = {
	paramsName: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object, PropTypes.string])),
	children: PropTypes.node.isRequired,
	encodeTheUri: PropTypes.bool,
	logicHandler: PropTypes.func
};
export default PrivateRoute;
